/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://lxarmxwkyrfvbaeri6e2tuxewm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:84fee258-fe74-414e-9869-894196ad59aa",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_VD9HpDf6M",
    "aws_user_pools_web_client_id": "1vl7tqe017letv7k48i730kq9k",
    "oauth": {
        "domain": "tes-behaviour-app.auth.us-east-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "HazardCardCounter-prod",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "hazardsfiles14a80-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
